import { render } from "./JobRoleDropdown.vue?vue&type=template&id=0846590f"
import script from "./JobRoleDropdown.vue?vue&type=script&lang=js"
export * from "./JobRoleDropdown.vue?vue&type=script&lang=js"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__